module.exports = __webpack_public_path__ + "img/72ab8ff.svg";